export default __webpack_public_path__ + "5c2514b66dbbb44ebfa6ded3122d276e.svg";